/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Ad_Trim_Success_ToastInputs */

const en_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event(s) trimmed to audio duration`)
};

const fr_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement(s) ajustes a la duree audio`)
};

const de_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis(se) auf Audiodauer gekürzt`)
};

const it_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento/i ridotto/i alla durata audio`)
};

const ru_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События обрезаны до аудиодлительности.`)
};

const es_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento(s) recortado(s) a la duración del audio`)
};

const zh_cn2_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件已剪辑至音频时长`)
};

const ja_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントはオーディオの長さに合わせてトリミングされました`)
};

const hi_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो अवधि के अनुसार इवेंट को छोटा कर दिया गया है।`)
};

const pt_pt2_shortcut_keys_ad_trim_success_toast = /** @type {(inputs: Shortcut_Keys_Ad_Trim_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento(s) reduzido(s) à duração de áudio`)
};

/**
* | output |
* | --- |
* | "Event(s) trimmed to audio duration" |
*
* @param {Shortcut_Keys_Ad_Trim_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_trim_success_toast = /** @type {((inputs?: Shortcut_Keys_Ad_Trim_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Trim_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "de") return de_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "it") return it_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "ru") return ru_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "es") return es_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "ja") return ja_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "hi") return hi_shortcut_keys_ad_trim_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_ad_trim_success_toast(inputs)
	return en_shortcut_keys_ad_trim_success_toast(inputs)
});